import state from "./state";

const minusNumberEl = document.querySelector(".product-number-selector > .remove")
const plusNumberEl = document.querySelector(".product-number-selector > .add")
const curSelectedEl = document.querySelector(".product-number-selector > .current-number")

state.addCurrentSelectedChangedCallback((num) => {
    curSelectedEl.innerHTML = num;
})

minusNumberEl.addEventListener("click", () => {
    const { currentSelected } = state;
    if (currentSelected > 1) {
        state.setCurrentSelected(currentSelected - 1)
    }
})

plusNumberEl.addEventListener("click", () => {
    state.setCurrentSelected(state.currentSelected + 1);
})